const dateFmt = new Intl.DateTimeFormat('ru-RU', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
})

// ISO → «7 июл. 2026». Пустой/битый вход — пустая строка (безопасно в JSX).
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return dateFmt.format(d)
}

// Зона момента канона времени: у человека с экраном она берётся у устройства —
// оно едет за ним само, без единого действия. Пустая строка — рантайм зону не
// отдал (в хабе это значит «не знаем», а не «UTC»).
export function deviceTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || ''
}
